import Resource from 'api/resource';

class TechStackResource extends Resource {
  constructor() {
    super('techstacks');
  }
}
export { TechStackResource as default };
